import { AvailabilityBlock } from '@mews-commander/data-access';
import { getAvailabilityBlock } from '@mews-commander/legacy-entities/src/ducks/availabilityBlocks';
import { useCommanderSelector } from '@mews-commander/utils';

export const useAvailabilityBlock = (availabilityBlockId: string | null | undefined): AvailabilityBlock | undefined =>
    useCommanderSelector((state) => getAvailabilityBlock(state, { id: availabilityBlockId ?? '' }));
